import { render, staticRenderFns } from "./InvalidateAudienceModal.vue?vue&type=template&id=5e877a9e&scoped=true&"
import script from "./InvalidateAudienceModal.vue?vue&type=script&lang=js&"
export * from "./InvalidateAudienceModal.vue?vue&type=script&lang=js&"
import style0 from "./InvalidateAudienceModal.vue?vue&type=style&index=0&id=5e877a9e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e877a9e",
  null
  
)

export default component.exports